import React from "react";
import Hero from "./components/dept-sports/Hero";
import Main from "./components/dept-sports/Main";
import ImportantLinksSlider from "./components/Home/ImportantLinksSlider";

const DeptSports = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    );
};

export default DeptSports;
